module.exports = __webpack_public_path__ + "30421a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-delivery.png
// module id = 1532
// module chunks = 0